
import { ISearchComponentsPaginatedResult } from "./ISearchComponentsPaginatedResult";
import { IComponent } from "./IComponent";
import { Component } from "./Component";
import { IBranch } from "./IBranch";
import { Branch } from "./Branch";
import { IPaginationInfoResult } from "./IPaginationInfoResult";
import { PaginationInfoResult } from "./PaginationInfoResult";


export class SearchComponentsPaginatedResult implements ISearchComponentsPaginatedResult
{
    components: IComponent[] = [];
    branches: IBranch[] = [];
    paginationInfo: IPaginationInfoResult  = new PaginationInfoResult();
}
